import styled from 'styled-components';

const RECBody = styled.div`
  flex-grow: 1;
`;

const RECItem = styled.div`
  background-color: var(--color-bg-weaker);
  border-radius: var(--size-border-radius-md);
  margin-top: 40px;
  padding: 24px;
`;

const RECItemBody = styled.div`
  align-items: flex-end;
  display: flex;
  gap: 24px;
`;

const RECItemShare = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-bg-stronger);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;
  margin-top: 32px;
  padding: 40px;
  position: relative;
`;

const RECItemShareTitle = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-bg-stronger);
  border-radius: var(--size-border-radius-pill);
  left: 40px;
  padding: 7px 12px;
  position: absolute;
  top: 0;
  transform: translateY(-50%);
`;

export { RECBody, RECItem, RECItemBody, RECItemShare, RECItemShareTitle };
